import { Component } from '@angular/core';

@Component({
  selector: 'app-error-login',
  templateUrl: './forbidden.component.html',
  styleUrls: ['./forbidden.component.scss']
})
export class ForbiddenComponent {

}
